import React from 'react';

import EditColumnsButton from '../../../../components/edit-columns-button';
import { useModal } from '../../../../hooks/use-modal';

import { EditEnhancedReturnsColumnsModal } from './edit-enhanced-returns-columns-modal';

export const EditEnhancedReturnsColumnsButton = () => {
  const { close, isOpen, open } = useModal();

  return (
    <>
      <EditColumnsButton onClick={open} />
      {isOpen && <EditEnhancedReturnsColumnsModal onClose={close} />}
    </>
  );
};
